import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "margin-r-half" }

import { onMounted, PropType, ref, watch } from "vue";
import { MetadataInstance } from "@/models/product-section.model";
import { useMetadataStore } from "@/stores/metadata.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextFree',
  props: {
  item: {
    required: true,
    type: Object as PropType<MetadataInstance>
  },
  productId: {
    required: true,
    type: Number
  }
},
  setup(__props) {

const metadataStore = useMetadataStore();

const props = __props;

const metadataValue = ref<string>("");
onMounted(() => {
  metadataValue.value = props.item.authored_text;
});
watch(
  () => props.item,
  newVal => {
    if (newVal) {
      metadataValue.value = newVal.authored_text;
    }
  }
);
const updateMetadataText = async (): Promise<void> => {
  const payload = {
    metadataInstance: {
      authored_text: metadataValue.value,
      id: props.item.id
    },
    productId: props.productId
  };
  await metadataStore.updateMetadataInstance(payload);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("strong", _hoisted_1, _toDisplayString(__props.item.metadata_definition.name) + ":", 1),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((metadataValue).value = $event)),
      type: "text",
      onChange: updateMetadataText
    }, null, 544), [
      [_vModelText, metadataValue.value]
    ])
  ]))
}
}

})